import Modal from './Modal';

/**
 * The first step of adding a Person by hand. It deliberately holds nothing but the explanation and the two
 * actions: people registered with Scouting should come in through the council's my.Scouting.org imports.
 * Proceeding opens the normal governed, duplicate-checked entry form.
 */
export default function ManualEntryNotice({ onCancel, onProceed }: { onCancel: () => void; onProceed: () => void }) {
  return (
    <Modal title="Add Person Manually" onClose={onCancel}>
      <p>
        Most people should be added to Compass through your council's my.Scouting.org imports. This ensures their
        Scouting identity, Member ID, and other National information remain connected to the authoritative Scouting
        record.
      </p>
      <p>
        Only create a Person manually when they need to exist in Compass but are not available through your council's
        my.Scouting.org data.
      </p>
      <p>
        If the person already exists in Compass but uses a different email address, do not create another Person. Have
        an authorized user add the additional email address as a secondary email on the existing Person.
      </p>
      <p>
        If this person is later included in a my.Scouting.org import, Compass should reconcile the imported identity
        with the existing Person rather than silently creating a duplicate. When Compass cannot establish that identity
        authoritatively, require human reconciliation rather than joining People based only on name, email, or phone.
      </p>
      <div className="actions">
        <button className="btn" onClick={onCancel}>
          Cancel
        </button>
        <button className="btn primary" onClick={onProceed}>
          Proceed with Manual Entry
        </button>
      </div>
    </Modal>
  );
}
